export default "__VITE_ASSET__CgbO2Nfw__"